import React from "react";
import Grid from "@material-ui/core/Grid";

const DisclaimerTextV2 = () => (
  <Grid item>
    <Grid container>
      <Grid item xs={12}><b>Risikohinweis zur Berücksichtigung Ihrer Nachhaltigkeitspräferenzen</b></Grid>
      <Grid item xs={12}>
        Sie sind nicht verpflichtet, sich für eine der dargestellten Nachhaltigkeitspräferenzen zu entscheiden.
        Wir als Anbieter sind bemüht, Ihnen ein Angebot unter Berücksichtigung von Nachhaltigkeitspräferenzen unterbreiten
        zu können. Bitte berücksichtigen Sie dabei, dass wir zum gegenwärtigen Zeitpunkt noch nicht auf eine ausreichende
        Datengrundlage von Unternehmen zurückgreifen können. Erst in Zukunft werden Unternehmen verpflichtet werden,
        detaillierte Angaben zum Anteil ihrer Investitionen und ihrer Umsätze in wirtschaftlichen Tätigkeiten, die z.B.
        der Taxonomieverordnung entsprechen, in ihrer nicht-finanziellen Berichterstattung zu machen. Diese Verpflichtungen
        werden nur größere Unternehmen betreffen, nicht aber kleinere und mittlere Unternehmen. Letztere werden
        voraussichtlich lediglich zu einer eingeschränkten Berichterstattung verpflichtet. Das Gleiche gilt für staatliche
        oder supranationale Emittenten. <b>Wir können daher keine Gewährleistung für die Erreichung Ihrer Nachhaltigkeitsziele übernehmen.</b>
      </Grid>
    </Grid>
  </Grid>
);

export default DisclaimerTextV2;